module.exports = __webpack_public_path__ + "36adf09ed43c6e72c62dd650204834dc.pdf";